export default __webpack_public_path__ + "static/media/1.ff2ce183.png";